import {
	customer,
	detailCustomer,
	alamat,
	topFive,
	riwayat,
	pagination,
	paginationAlamat,
	search,
	searchAlamat,
	dataCreateCustomer,
	alamatTemp,
	scrollPosition,
} from "./state"

const mutations = {
	// mutate data customer
	setCustomer: (state, res) => {
		if (state.customer.data !== undefined) {
			if (res.data === null) {
				return
			}
			state.customer.data = [...state.customer.data, ...res.data];
		} else {
			state.customer = res
			if (res.data === null) {
				res.data = []
			}
		}
	},
	setDataCreateCustomer: (state, customer) => {
		state.customer = customer
	},
	setDetailCustomer: (state, customer) => {
		state.detailCustomer = customer
	},
	setDetailCustomer2: (state, customer) => {
		state.detailCustomer2 = customer
	},
	setTopFive: (state, topFive) => {
		state.topFive = topFive
	},
	setRiwayat: (state, riwayat) => {
		state.riwayat = riwayat
	},
	resetCustomer: (state) => {
		state.customer = customer()
	},
	resetDataCreateCustomer: (state) => {
		state.dataCreateCustomer = dataCreateCustomer()
	},
	resetDetailCustomer: (state) => {
		state.detailCustomer = detailCustomer()
	},
	resetTopFive: (state) => {
		state.topFive = topFive()
	},
	resetRiwayat: (state) => {
		state.riwayat = riwayat()
	},

	// mutate alamat
	setAlamat: (state, res) => {
		if (state.alamat.data !== undefined) {
			state.alamat.data = [...state.alamat.data, ...res.data];
		} else {
			state.alamat = res
		}
	},
	resetAlamat: (state) => {
		state.alamat = alamat()
	},

	// pagination
	setNextPagination: (state, payload) => {
		state.pagination.length = payload.data.length
		state.pagination.pageNumber++
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
	},
	resetPagination: (state, e) => {
		state.pagination = pagination()
	},
	setNextPaginationAlamat: (state, payload) => {
		state.paginationAlamat.length = payload.data.length
		state.paginationAlamat.pageNumber++
		state.paginationAlamat.offset = state.paginationAlamat.pageNumber * state.paginationAlamat.limit
	},
	resetPaginationAlamat: (state, e) => {
		state.paginationAlamat = paginationAlamat()
	},

	// search
	setIsSearchCustomer: (state, bool) => {
		state.isSerachCustomer = bool
	},
	setIsSearchAlamat: (state, bool) => {
		state.isSearchAlamat = bool
	},
	setSearch: (state, search) => {
		state.search.key = search;
	},
	setSearchAlamat: (state, search) => {
		state.searchAlamat.key = search
	},
	resetSearch: (state) => {
		state.search = search();
	},
	resetSearchAlamat: (state) => {
		state.searchAlamat = searchAlamat();
	},

	// alamat
	setAlamatTemp: (state, alamatTemp) => {
		state.alamatTemp = alamatTemp
	},
	resetAlamatTemp: (state) => {
		state.alamatTemp = alamatTemp()
	},

	setScrollPosition: (state, positionY) => {
		state.scrollPosition = positionY - 200
	}
}

export default mutations